export default __webpack_public_path__ + "static/media/x.100b8dd5.svg";